// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2rtU_","left":"StickyBox_left__3IzQm","right":"StickyBox_right__18TRE"};